import React, { useState, useEffect } from "react";
import { blogAPI } from "../services/api";
import API_BASE_URL from "../config/api";
import BlogCard from "../components/BlogCard";
import LoadingScreen from "../components/LoadingScreen";
import { useLang } from "../context/LanguageContext";

import "./BlogStyles.css";
import { Helmet } from "react-helmet-async";

const BlogComponent = () => {
  const { nl } = useLang();
  const L = (obj, field) => (nl && obj?.[field + '_nl']) || obj?.[field] || '';
  const [blogs, setBlogs] = useState([]);
  const [blogPageData, setBlogPageData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const blogsPerPage = 6;
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/seo/blog`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSeoData(data.data);
        }
      })
      .catch((err) => console.error("SEO fetch error:", err));
  }, []);

  useEffect(() => {
    Promise.all([
      blogAPI.getAll(),
      fetch(`${API_BASE_URL}/api/blogs/page`).then((res) => res.json()),
    ])
      .then(([blogsResponse, pageResponse]) => {
        setBlogs(blogsResponse.data.data || []);
        if (pageResponse.success) {
          setBlogPageData(pageResponse.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setBlogs([]);
        setLoading(false);
      });
  }, []);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for subscribing!");
    setEmail("");
  };

  const totalPages = Math.ceil(blogs.length / blogsPerPage);
  const startIndex = (currentPage - 1) * blogsPerPage;
  const currentBlogs = blogs.slice(startIndex, startIndex + blogsPerPage);

  const handlePageChange = (page) => {
    if (page === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (page === "next" && currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    } else if (typeof page === "number") {
      setCurrentPage(page);
    }
    window.scrollTo(0, 0);
  };

  console.log("This is SEO DATA: ", seoData);

  if (loading) return <LoadingScreen />;

  return (
    <div className="blog-page">
      <Helmet>
        <title>{seoData?.title || 'Aurelia Technology'}</title>
        {seoData?.description && <meta name="description" content={seoData.description} />}
        {seoData?.keywords && <meta name="keywords" content={seoData.keywords} />}
        {seoData?.canonicalUrl && <link rel="canonical" href={seoData.canonicalUrl} />}
        <meta property="og:title" content={seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta property="og:description" content={seoData?.ogDescription || seoData?.description || ''} />
        {seoData?.ogImage && <meta property="og:image" content={seoData.ogImage} />}
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData?.twitterTitle || seoData?.ogTitle || seoData?.title || 'Aurelia Technology'} />
        <meta name="twitter:description" content={seoData?.twitterDescription || seoData?.ogDescription || seoData?.description || ''} />
        {(seoData?.twitterImage || seoData?.ogImage) && <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />}
      </Helmet>
      {/* Banner */}
      <section
        className="blog-banner"
        style={{
          backgroundImage: blogPageData?.bannerSection?.image
            ? `url(${blogPageData.bannerSection.image})`
            : "url(https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=1200&h=400&fit=crop)",
        }}
      >
        <div className="banner-overlay"></div>
        <div className="blog-banner-content">
          <h1>{L(blogPageData?.bannerSection, 'title') || (nl ? 'BLOG & INZICHTEN' : 'BLOG & INSIGHTS')}</h1>
          <p>
            {L(blogPageData?.bannerSection, 'subtitle') ||
              (nl ? 'Blijf op de hoogte van de laatste trends en innovaties in technologie' : 'Stay updated with the latest trends and innovations in technology')}
          </p>
        </div>
      </section>

      {/* Blog Posts */}
      <section className="blog-section">
        <div className="container">
          <div className="section-header">
            <h2>{L(blogPageData?.articlesSection, 'title') || (nl ? 'Laatste artikelen' : 'Latest Articles')}</h2>
            <p>
              {L(blogPageData?.articlesSection, 'subtitle') ||
                (nl ? 'Deskundige inzichten en thought leadership van onze technologiespecialisten' : 'Expert insights and thought leadership from our technology specialists')}
            </p>
          </div>

          <div className="blog-grid">
            {currentBlogs.length > 0 ? (
              currentBlogs.map((blog) => (
                <BlogCard key={blog._id} blog={blog} />
              ))
            ) : (
              <p className="no-blogs">{nl ? 'Nog geen blogs beschikbaar.' : 'No blogs available yet.'}</p>
            )}
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                className={`page-btn ${currentPage === 1 ? "disabled" : ""}`}
                onClick={() => handlePageChange("prev")}
                disabled={currentPage === 1}
              >
                {nl ? 'Vorige' : 'Previous'}
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                (page) => (
                  <button
                    key={page}
                    className={`page-btn ${page === currentPage ? "active" : ""}`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                ),
              )}
              <button
                className={`page-btn ${currentPage === totalPages ? "disabled" : ""}`}
                onClick={() => handlePageChange("next")}
                disabled={currentPage === totalPages}
              >
                {nl ? 'Volgende' : 'Next'}
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default BlogComponent;
